import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';

import { ApiService } from '@features/api';

import { SystemPageSeoResponse } from '../models';

@Injectable({ providedIn: 'root' })
export class SystemPageService {
  #api = inject(ApiService);

  get(key: string) {
    return this.#api
      .get<{ system_page: SystemPageSeoResponse }>(`/system-pages/${key}`)
      .pipe(map(({ system_page }) => system_page));
  }
}
